import { Component, Input, OnInit } from "@angular/core";

import { ViewCell } from "ng2-smart-table";

@Component({
  template: `<h6
    [ngClass]="renderValue < 0 ? 'text-danger' : 'text-primary'"
    class="text-primary"
    style="text-align: right;"
  >
    {{ renderValue | number }}
  </h6>`,
})
export class StbCustomRenderNumberComponent implements ViewCell, OnInit {
  renderValue: number;

  @Input() value: number;
  @Input() rowData: any;

  ngOnInit() {
    this.renderValue = isNaN(this.value) ? 0 : this.value;
  }
}
